<template>
  <main class="main main--has-floating-buttons">
    <portal to="headerTitle">
      {{ $t('admin.pageTaxSets.title') }}
    </portal>

    <template v-if="taxSets !== null">
      <card :title="$t('admin.pageTaxSets.card.taxSets')" cols="12">
        <hm-card-inner :full-size="true">
          <hm-col cols="12">
            <template v-for="taxSet in taxSets" v-if="!taxSet.deleted">
              <hm-card-inner-line :title="getName(taxSet)" :clickable="true" :key="taxSet.id" @click="routeToTaxSet(taxSet)" />
            </template>
          </hm-col>
        </hm-card-inner>
      </card>

      <card v-if="!isEmpty(deletedTaxSets)" :title="$t('admin.pageTaxSets.card.deletedTaxSets')" cols="12" card-type="collapsible">
        <hm-card-inner :full-size="true">
          <hm-card-inner v-for="taxSet in deletedTaxSets"
                         :title="getName(taxSet)"
                         :clickable="true"
                         :key="taxSet.id"
                         @click="routeToTaxSet(taxSet)" />
        </hm-card-inner>
      </card>
    </template>

    <hm-floating-buttons id="actions" ref="floatingButtons">
      <hm-floating-button :label="$t('admin.pageTaxSets.actions.more')" icon="plus" color="blue">
        <hm-floating-child-button :label="$t('admin.pageTaxSets.actions.addTaxSet')" icon="plus" color="blue" @click="addTaxSet()" />
      </hm-floating-button>
    </hm-floating-buttons>
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import vue2Dropzone from 'vue2-dropzone';
import draggable from 'vuedraggable';
import { cloneDeep, flattenDeep, groupBy, isEmpty, isNil, keyBy, sortBy } from 'lodash';
import SaveWatchMixin from '@/mixins/SaveWatchMixin';

export default {
  name: 'PageTaxSets',

  mixins: [HotelmeisterMixin, SaveWatchMixin],

  data() {
    return {
      taxSets: null,
    };
  },

  computed: {
    deletedTaxSets: function () {
      return isNil(this.taxSets) ? null : this.taxSets.filter(it => it.deleted === true);
    },
    enums: function () {
      return this.$store.getters['enums/enums'];
    },
  },

  watch: {
  },

  created: function () {
    this.loadData();
  },

  updated() {
  },

  beforeDestroy() {
  },

  methods: {
    loadData() {
      this.axios.get(this.serviceUrls.taxSet.list(this))
        .then((response) => {
          this.taxSets = sortBy(response.data.data, ['name']);

          this.$serviceBus.$emit('taxSet.list', this.taxSets);
        });
    },
    addTaxSet() {
      this.axios.post(this.serviceUrls.taxSet.list(this), {
        name: this.$t('admin.pageTaxSets.newTaxSetName') || 'New',
      })
        .then((response) => {
          this.loadData();
          this.$serviceBus.$emit('hotelSettings.update');
        })
        .catch((error) => {
          if (isNil(error.response)) this.showErrorMessage();
          this.showMessages(error.response);
        });
    },
    getName(taxSet) {
      const name = isNil(taxSet) ? null : taxSet.name;
      if (isNil(name)) return '-';
      let ret = name;

      const details = '';


      if (!isNil(ret)) {
        ret = ret.trim();
      }

      if (isEmpty(ret)) {
        ret = '-';
      }

      ret = `${ret}<span class="color--gray">${details}</span>`;

      return ret || '-';
    },
    routeToTaxSet(taxSet) {
      this.$router.push({
        name: 'taxSet',
        params: {
          taxSetId: taxSet.id,
        },
      });
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
</style>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/PageTaxSets.vue